import * as z from "../../../vendor/zod/src/index";
import TraderConfiguration from "./TraderConfiguration";
export default z.object({
    trader_configuration: TraderConfiguration,
});
